import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type BestBoxTypeEntryDto = {
   __typename?: 'BestBoxTypeEntryDTO';
  current?: Maybe<BestBoxTypeEntryStateDto>;
  calc?: Maybe<BestBoxTypeEntryStateDto>;
  material?: Maybe<MaterialDto>;
};

export type BestBoxTypeEntryStateDto = {
   __typename?: 'BestBoxTypeEntryStateDTO';
  boxType?: Maybe<BoxTypeDto>;
  fuelLevel?: Maybe<Scalars['Float']>;
};

export type BestBoxTypesAggDto = {
   __typename?: 'BestBoxTypesAggDTO';
  boxType?: Maybe<BoxTypeDto>;
  amount?: Maybe<Scalars['Int']>;
};

export type BestBoxTypesOptAggResultDto = {
   __typename?: 'BestBoxTypesOptAggResultDTO';
  agg?: Maybe<Array<Maybe<BestBoxTypesAggDto>>>;
};

export type BestBoxTypesOptAggResultResourceList = {
   __typename?: 'BestBoxTypesOptAggResultResourceList';
  data?: Maybe<Array<Maybe<BestBoxTypesOptAggResultDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type BestBoxTypesOptCalcDto = {
  fuelLevel: Scalars['Float'];
};

export type BestBoxTypesOptResultDto = {
   __typename?: 'BestBoxTypesOptResultDTO';
  entries?: Maybe<Array<Maybe<BestBoxTypeEntryDto>>>;
};

export type BestBoxTypesOptResultResourceList = {
   __typename?: 'BestBoxTypesOptResultResourceList';
  data?: Maybe<Array<Maybe<BestBoxTypesOptResultDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type BoxTypeAggregateDto = {
   __typename?: 'BoxTypeAggregateDTO';
  boxType?: Maybe<BoxTypeDto>;
  count?: Maybe<Scalars['Int']>;
};

export type BoxTypeCreateInput = {
  name: Scalars['String'];
  inner?: Maybe<BoxTypeSizeInput>;
  outer?: Maybe<BoxTypeSizeInput>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type BoxTypeDto = {
   __typename?: 'BoxTypeDTO';
  uuid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  inner?: Maybe<BoxTypeSize>;
  outer?: Maybe<BoxTypeSize>;
  isValid?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type BoxTypeResourceList = {
   __typename?: 'BoxTypeResourceList';
  data?: Maybe<Array<Maybe<BoxTypeDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type BoxTypeSize = {
   __typename?: 'BoxTypeSize';
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  depth?: Maybe<Scalars['Int']>;
};

export type BoxTypeSizeInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  depth?: Maybe<Scalars['Int']>;
};

export type BoxTypeStatDto = {
   __typename?: 'BoxTypeStatDTO';
  count?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Int']>;
  valid?: Maybe<Scalars['Int']>;
};

export type BoxTypeUpdateInput = {
  name?: Maybe<Scalars['String']>;
  inner?: Maybe<BoxTypeSizeInput>;
  outer?: Maybe<BoxTypeSizeInput>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type EfficiencyNumberPerRackParamsDto = {
  horizontalFactor?: Maybe<Scalars['Float']>;
  verticalDownFactor?: Maybe<Scalars['Float']>;
  verticalUpFactor?: Maybe<Scalars['Float']>;
};

export type Error = {
   __typename?: 'Error';
  message?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type ExecutionResultResource = {
   __typename?: 'ExecutionResultResource';
  success?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Error>;
};

export type FilterParam = {
  field?: Maybe<Scalars['String']>;
  expected?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  custom?: Maybe<Scalars['String']>;
};

export type FlowRackBoxDto = {
   __typename?: 'FlowRackBoxDTO';
  count?: Maybe<Scalars['Int']>;
  box?: Maybe<BoxTypeDto>;
};

export type FlowRackBoxUpdateDto = {
  count?: Maybe<Scalars['Int']>;
  boxUuid?: Maybe<Scalars['String']>;
};

export type FuelLevelStatDto = {
   __typename?: 'FuelLevelStatDTO';
  avg?: Maybe<Scalars['Float']>;
  amountOfNoFuelLevel?: Maybe<Scalars['Int']>;
  amountOfInvalidFuelLevel?: Maybe<Scalars['Int']>;
  amountWithFuelLevel?: Maybe<Scalars['Int']>;
};

export type GenericDto = {
   __typename?: 'GenericDTO';
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GenericDtoResourceList = {
   __typename?: 'GenericDTOResourceList';
  data?: Maybe<Array<Maybe<GenericDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type MaterialDto = {
   __typename?: 'MaterialDTO';
  uuid?: Maybe<Scalars['ID']>;
  number?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  mrpType?: Maybe<Scalars['String']>;
  customerGroup?: Maybe<Scalars['String']>;
  storageBin?: Maybe<Scalars['String']>;
  packageType?: Maybe<PackageTypeDto>;
};

export type MaterialResourceList = {
   __typename?: 'MaterialResourceList';
  data?: Maybe<Array<Maybe<MaterialDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type MaterialStatDto = {
   __typename?: 'MaterialStatDTO';
  count?: Maybe<Scalars['Int']>;
  inActive?: Maybe<Scalars['Int']>;
  hasPlace?: Maybe<Scalars['Int']>;
  needToBePlaced?: Maybe<Scalars['Int']>;
  invalid?: Maybe<Scalars['Int']>;
  all?: Maybe<Scalars['Int']>;
};

export type Mutation = {
   __typename?: 'Mutation';
  addBoxType?: Maybe<BoxTypeResourceList>;
  updateBoxType?: Maybe<BoxTypeResourceList>;
  deleteBoxType?: Maybe<ExecutionResultResource>;
  bootstrapStorageConfigs?: Maybe<ExecutionResultResource>;
  preprocessAllBoxTypes?: Maybe<ExecutionResultResource>;
  importMaterials?: Maybe<ExecutionResultResource>;
  importPackageTypes?: Maybe<ExecutionResultResource>;
  calculateCurrentFuelLevels?: Maybe<ExecutionResultResource>;
  calculateEfficiencyNumber?: Maybe<ExecutionResultResource>;
  optimizeStorageLocationsForZones?: Maybe<ExecutionResultResource>;
  optimizeBoxFuelLevels?: Maybe<ExecutionResultResource>;
  calculateNeededBoxes?: Maybe<ExecutionResultResource>;
  addPackageType?: Maybe<PackageTypeResourceList>;
  updatePackageType?: Maybe<PackageTypeResourceList>;
  deletePackageType?: Maybe<ExecutionResultResource>;
  updateStorageConfig?: Maybe<StorageConfigResourceList>;
  deleteStorageConfig?: Maybe<ExecutionResultResource>;
  deleteUnusedStorageConfigs?: Maybe<ExecutionResultResource>;
  addTenant?: Maybe<TenantResourceList>;
  resetTenant?: Maybe<ExecutionResultResource>;
  updateTenant?: Maybe<TenantResourceList>;
  addUser?: Maybe<UserResourceList>;
  updateUser?: Maybe<UserResourceList>;
  deleteUser?: Maybe<ExecutionResultResource>;
  assignTenant?: Maybe<ExecutionResultResource>;
};


export type MutationAddBoxTypeArgs = {
  boxType?: Maybe<BoxTypeCreateInput>;
};


export type MutationUpdateBoxTypeArgs = {
  id?: Maybe<Scalars['String']>;
  boxType?: Maybe<BoxTypeUpdateInput>;
};


export type MutationDeleteBoxTypeArgs = {
  id?: Maybe<Scalars['String']>;
};


export type MutationCalculateEfficiencyNumberArgs = {
  config?: Maybe<EfficiencyNumberPerRackParamsDto>;
};


export type MutationOptimizeStorageLocationsForZonesArgs = {
  zones?: Maybe<Array<Maybe<Scalars['String']>>>;
  fillingLevel: Scalars['Float'];
  withFilling?: Maybe<Scalars['Boolean']>;
  trendFactor?: Maybe<Scalars['Float']>;
  maxBoxSkip?: Maybe<Scalars['Int']>;
};


export type MutationOptimizeBoxFuelLevelsArgs = {
  fuelLevel?: Maybe<Scalars['Float']>;
  availableBoxes?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationCalculateNeededBoxesArgs = {
  fillingLevel?: Maybe<Scalars['Float']>;
  selectedBoxes?: Maybe<Array<Maybe<SelectedBoxDto>>>;
};


export type MutationAddPackageTypeArgs = {
  p?: Maybe<PackageTypeCreateInput>;
};


export type MutationUpdatePackageTypeArgs = {
  id?: Maybe<Scalars['String']>;
  packageType?: Maybe<PackageTypeUpdateInput>;
};


export type MutationDeletePackageTypeArgs = {
  id?: Maybe<Scalars['String']>;
};


export type MutationUpdateStorageConfigArgs = {
  uuid: Scalars['String'];
  config: StorageConfigUpdateInput;
};


export type MutationDeleteStorageConfigArgs = {
  id?: Maybe<Scalars['String']>;
};


export type MutationAddTenantArgs = {
  tenant?: Maybe<TenantInput>;
};


export type MutationUpdateTenantArgs = {
  id?: Maybe<Scalars['String']>;
  tenant?: Maybe<TenantInput>;
};


export type MutationAddUserArgs = {
  newUserCreate?: Maybe<UserCreateInput>;
};


export type MutationUpdateUserArgs = {
  id?: Maybe<Scalars['String']>;
  user?: Maybe<UserUpdateInput>;
};


export type MutationDeleteUserArgs = {
  id?: Maybe<Scalars['String']>;
};


export type MutationAssignTenantArgs = {
  userId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type PackageTypeCreateInput = {
  name: Scalars['String'];
  width: Scalars['Float'];
  height: Scalars['Float'];
  depth: Scalars['Float'];
};

export type PackageTypeDto = {
   __typename?: 'PackageTypeDTO';
  uuid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  isValid?: Maybe<Scalars['Boolean']>;
};

export type PackageTypeResourceList = {
   __typename?: 'PackageTypeResourceList';
  data?: Maybe<Array<Maybe<PackageTypeDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type PackageTypeStatDto = {
   __typename?: 'PackageTypeStatDTO';
  count?: Maybe<Scalars['Int']>;
  valid?: Maybe<Scalars['Int']>;
};

export type PackageTypeUpdateInput = {
  name?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
};

export type PageableParam = {
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type PageInfo = {
   __typename?: 'PageInfo';
  offset?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

export type PickZoneDto = {
   __typename?: 'PickZoneDTO';
  uuid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type PickZoneResourceList = {
   __typename?: 'PickZoneResourceList';
  data?: Maybe<Array<Maybe<PickZoneDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type ProcessLogDto = {
   __typename?: 'ProcessLogDTO';
  uuid?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  meta2?: Maybe<ProcessLogMetaDto>;
};

export type ProcessLogMetaDto = {
   __typename?: 'ProcessLogMetaDTO';
  params?: Maybe<Array<Maybe<ProcessLogMetaParamDto>>>;
  result?: Maybe<Array<Maybe<ProcessLogMetaParamDto>>>;
};

export type ProcessLogMetaParamDto = {
   __typename?: 'ProcessLogMetaParamDTO';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProcessLogResourceList = {
   __typename?: 'ProcessLogResourceList';
  data?: Maybe<Array<Maybe<ProcessLogDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type Query = {
   __typename?: 'Query';
  getBoxType?: Maybe<BoxTypeResourceList>;
  getBoxTypes?: Maybe<BoxTypeResourceList>;
  getEntries?: Maybe<StorageEntryResourceList>;
  getCustomerGroups?: Maybe<GenericDtoResourceList>;
  getMaterial?: Maybe<MaterialResourceList>;
  getMaterials?: Maybe<MaterialResourceList>;
  getBestBoxTypesForStorageEntries?: Maybe<BestBoxTypesOptResultResourceList>;
  getBestBoxTypesForStorageEntriesAgg?: Maybe<BestBoxTypesOptAggResultResourceList>;
  getPackageType?: Maybe<PackageTypeResourceList>;
  getPackageTypes?: Maybe<PackageTypeResourceList>;
  getPickZone?: Maybe<PickZoneResourceList>;
  getPickZones?: Maybe<PickZoneResourceList>;
  getProcessLogs?: Maybe<ProcessLogResourceList>;
  getStatistics?: Maybe<StatisticDto>;
  getStorageConfig?: Maybe<StorageConfigResourceList>;
  getStorageConfigs?: Maybe<StorageConfigResourceList>;
  getStorageEntry?: Maybe<StorageEntryResourceList>;
  getStorageEntries?: Maybe<StorageEntryResourceList>;
  getStorageHierarchy?: Maybe<StorageHierarchy>;
  getBoxesPerZone?: Maybe<BoxTypeResourceList>;
  getZones?: Maybe<GenericDtoResourceList>;
  getRacksPerZone?: Maybe<GenericDtoResourceList>;
  getStorageConfigPerZone?: Maybe<StorageConfigResourceList>;
  getTenant?: Maybe<TenantResourceList>;
  getTenants?: Maybe<TenantResourceList>;
  getMe?: Maybe<UserResourceList>;
  getUsers?: Maybe<UserResourceList>;
};


export type QueryGetBoxTypeArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetBoxTypesArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetEntriesArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetCustomerGroupsArgs = {
  q?: Maybe<Scalars['String']>;
};


export type QueryGetMaterialArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetMaterialsArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetBestBoxTypesForStorageEntriesArgs = {
  pagination?: Maybe<PageableParam>;
  options: BestBoxTypesOptCalcDto;
};


export type QueryGetBestBoxTypesForStorageEntriesAggArgs = {
  pagination?: Maybe<PageableParam>;
  options: BestBoxTypesOptCalcDto;
};


export type QueryGetPackageTypeArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetPackageTypesArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetPickZoneArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetPickZonesArgs = {
  pagination?: Maybe<PageableParam>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetProcessLogsArgs = {
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetStorageConfigArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetStorageConfigsArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetStorageEntryArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetStorageEntriesArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetBoxesPerZoneArgs = {
  zone?: Maybe<Scalars['String']>;
};


export type QueryGetZonesArgs = {
  q?: Maybe<Scalars['String']>;
};


export type QueryGetRacksPerZoneArgs = {
  q?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
};


export type QueryGetStorageConfigPerZoneArgs = {
  zone?: Maybe<Scalars['String']>;
};


export type QueryGetTenantArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryGetTenantsArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type QueryGetUsersArgs = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};

export type RackConfigDto = {
   __typename?: 'RackConfigDTO';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type RackConfigUpdateDto = {
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type SelectedBoxDto = {
  boxTypeUuid: Scalars['String'];
  maxPerPlace: Scalars['Int'];
  maxSlots: Scalars['Int'];
  maxBoxes: Scalars['Int'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortParam = {
  field?: Maybe<Scalars['String']>;
  order?: Maybe<SortDirection>;
};

export type StatisticDto = {
   __typename?: 'StatisticDTO';
  aggregateAvailableBoxTypes?: Maybe<Array<Maybe<BoxTypeAggregateDto>>>;
  aggregateBoxTypes?: Maybe<Array<Maybe<BoxTypeAggregateDto>>>;
  materialStat?: Maybe<MaterialStatDto>;
  boxTypeStat?: Maybe<BoxTypeStatDto>;
  packageTypeStat?: Maybe<PackageTypeStatDto>;
  storageEntryStat?: Maybe<StorageEntryStatDto>;
  storageStructureStat?: Maybe<StorageStructureStatDto>;
  fuelLevelStat?: Maybe<FuelLevelStatDto>;
  storageConfigStat?: Maybe<StorageConfigStatDto>;
};

export type StorageConfigDto = {
   __typename?: 'StorageConfigDTO';
  uuid?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  zoneEffFactor?: Maybe<Scalars['Float']>;
  effCalcDone?: Maybe<Scalars['Boolean']>;
  currentPickZone?: Maybe<StorageConfigZonePickZoneDto>;
  estimatedPickZone?: Maybe<StorageConfigZonePickZoneDto>;
  customerGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  isFlowRackZone?: Maybe<Scalars['Boolean']>;
  bestPosition?: Maybe<Scalars['String']>;
  racks?: Maybe<Array<Maybe<RackConfigDto>>>;
  flowRackBoxes?: Maybe<Array<Maybe<FlowRackBoxDto>>>;
};

export type StorageConfigResourceList = {
   __typename?: 'StorageConfigResourceList';
  data?: Maybe<Array<Maybe<StorageConfigDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type StorageConfigStatDto = {
   __typename?: 'StorageConfigStatDTO';
  count?: Maybe<Scalars['Int']>;
  valid?: Maybe<Scalars['Int']>;
};

export type StorageConfigUpdateInput = {
  currentPickZone?: Maybe<StorageConfigZonePickZoneInput>;
  estimatedPickZone?: Maybe<StorageConfigZonePickZoneInput>;
  zoneEffFactor?: Maybe<Scalars['Float']>;
  customerGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  isFlowRackZone?: Maybe<Scalars['Boolean']>;
  bestPosition?: Maybe<Scalars['String']>;
  racks?: Maybe<Array<Maybe<RackConfigUpdateDto>>>;
  flowRackBoxes?: Maybe<Array<Maybe<FlowRackBoxUpdateDto>>>;
};

export type StorageConfigZonePickZoneDto = {
   __typename?: 'StorageConfigZonePickZoneDTO';
  next?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
};

export type StorageConfigZonePickZoneInput = {
  next?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
};

export type StorageEntryDto = {
   __typename?: 'StorageEntryDTO';
  uuid?: Maybe<Scalars['ID']>;
  zone?: Maybe<Scalars['String']>;
  rack?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  effNumber?: Maybe<Scalars['Float']>;
  fuelLevel?: Maybe<Scalars['Float']>;
  direction?: Maybe<Scalars['String']>;
  currentStock?: Maybe<Scalars['Int']>;
  maxStock?: Maybe<Scalars['Int']>;
  avg3Month?: Maybe<Scalars['Int']>;
  avg12Month?: Maybe<Scalars['Int']>;
  material?: Maybe<MaterialDto>;
  boxType?: Maybe<BoxTypeDto>;
  isEmpty?: Maybe<Scalars['Boolean']>;
  isOverflow?: Maybe<Scalars['Boolean']>;
  revision?: Maybe<Scalars['String']>;
};

export type StorageEntryResourceList = {
   __typename?: 'StorageEntryResourceList';
  data?: Maybe<Array<Maybe<StorageEntryDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type StorageEntryStatAnomaly = {
   __typename?: 'StorageEntryStatAnomaly';
  missingBoxTypes?: Maybe<Scalars['Int']>;
  missingLocations?: Maybe<Scalars['Int']>;
};

export type StorageEntryStatDto = {
   __typename?: 'StorageEntryStatDTO';
  count?: Maybe<Scalars['Int']>;
  reserved?: Maybe<Scalars['Int']>;
  inUse?: Maybe<Scalars['Int']>;
  free?: Maybe<Scalars['Int']>;
  anomaly?: Maybe<StorageEntryStatAnomaly>;
};

export type StorageHierarchy = {
   __typename?: 'StorageHierarchy';
  data?: Maybe<Array<Maybe<StorageHierarchyZone>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type StorageHierarchyLevel = {
   __typename?: 'StorageHierarchyLevel';
  level?: Maybe<Scalars['String']>;
  positions?: Maybe<Array<Maybe<StorageHierarchyPosition>>>;
};

export type StorageHierarchyPosition = {
   __typename?: 'StorageHierarchyPosition';
  position?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<StorageEntryDto>>>;
};

export type StorageHierarchyRack = {
   __typename?: 'StorageHierarchyRack';
  rack?: Maybe<Scalars['String']>;
  levels?: Maybe<Array<Maybe<StorageHierarchyLevel>>>;
};

export type StorageHierarchyZone = {
   __typename?: 'StorageHierarchyZone';
  zone?: Maybe<Scalars['String']>;
  racks?: Maybe<Array<Maybe<StorageHierarchyRack>>>;
};

export type StorageStructureStatDto = {
   __typename?: 'StorageStructureStatDTO';
  pickZones?: Maybe<Scalars['Int']>;
  zones?: Maybe<Scalars['Int']>;
  racks?: Maybe<Scalars['Int']>;
  levels?: Maybe<Scalars['Int']>;
  positions?: Maybe<Scalars['Int']>;
  sections?: Maybe<Scalars['Int']>;
  customerGroups?: Maybe<Scalars['Int']>;
};

export type Subscription = {
   __typename?: 'Subscription';
  getStockUpdate?: Maybe<Scalars['Int']>;
};

export type TenantConfigDto = {
   __typename?: 'TenantConfigDTO';
  desiredFuelLevel?: Maybe<Scalars['Float']>;
  storageLocationConfig?: Maybe<TenantStorageLocationConfig>;
  efficiencyCalcSetting?: Maybe<TenantEfficiencyCalcSettingDto>;
};

export type TenantConfigInputDto = {
  storageLocationConfig?: Maybe<TenantStorageLocationInputConfigDto>;
  efficiencyCalcSetting?: Maybe<TenantEfficiencyCalcSettingInputDto>;
  desiredFuelLevel?: Maybe<Scalars['Float']>;
};

export type TenantDto = {
   __typename?: 'TenantDTO';
  uuid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  config?: Maybe<TenantConfigDto>;
};

export type TenantEfficiencyCalcSettingDto = {
   __typename?: 'TenantEfficiencyCalcSettingDTO';
  verticalUp?: Maybe<Scalars['Float']>;
  verticalDown?: Maybe<Scalars['Float']>;
  horizontal?: Maybe<Scalars['Float']>;
};

export type TenantEfficiencyCalcSettingInputDto = {
  verticalUp?: Maybe<Scalars['Float']>;
  verticalDown?: Maybe<Scalars['Float']>;
  horizontal?: Maybe<Scalars['Float']>;
};

export type TenantInput = {
  name?: Maybe<Scalars['String']>;
  config?: Maybe<TenantConfigInputDto>;
};

export type TenantResourceList = {
   __typename?: 'TenantResourceList';
  data?: Maybe<Array<Maybe<TenantDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export type TenantStorageLocationConfig = {
   __typename?: 'TenantStorageLocationConfig';
  zone?: Maybe<Scalars['Int']>;
  rack?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  section?: Maybe<Scalars['Int']>;
};

export type TenantStorageLocationInputConfigDto = {
  zone?: Maybe<Scalars['Int']>;
  rack?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  section?: Maybe<Scalars['Int']>;
};

export type UserCreateInput = {
  name: Scalars['String'];
  surname: Scalars['String'];
  username: Scalars['String'];
  email: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRolesDto>>>;
};

export type UserDto = {
   __typename?: 'UserDTO';
  uuid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRolesDto>>>;
  tenant?: Maybe<TenantDto>;
};

export type UserResourceList = {
   __typename?: 'UserResourceList';
  data?: Maybe<Array<Maybe<UserDto>>>;
  meta?: Maybe<PageInfo>;
  error?: Maybe<Error>;
};

export enum UserRolesDto {
  Admin = 'admin',
  User = 'user',
  Developer = 'developer',
  SuperAdmin = 'superAdmin'
}

export type UserUpdateInput = {
  name: Scalars['String'];
  surname: Scalars['String'];
  email: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<UserRolesDto>>>;
};

export type AddBoxTypeMutationVariables = {
  boxType?: Maybe<BoxTypeCreateInput>;
};


export type AddBoxTypeMutation = (
  { __typename?: 'Mutation' }
  & { addBoxType?: Maybe<(
    { __typename?: 'BoxTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeDTO' }
      & Pick<BoxTypeDto, 'uuid' | 'name' | 'isValid' | 'isActive'>
      & { inner?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )>, outer?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'offset' | 'count' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type UpdateBoxTypeMutationVariables = {
  id?: Maybe<Scalars['String']>;
  boxType?: Maybe<BoxTypeUpdateInput>;
};


export type UpdateBoxTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateBoxType?: Maybe<(
    { __typename?: 'BoxTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeDTO' }
      & Pick<BoxTypeDto, 'uuid' | 'name' | 'isValid' | 'isActive'>
      & { inner?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )>, outer?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'offset' | 'count' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type DeleteBoxTypeMutationVariables = {
  id?: Maybe<Scalars['String']>;
};


export type DeleteBoxTypeMutation = (
  { __typename?: 'Mutation' }
  & { deleteBoxType?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type CurrentBoxtypesQueryVariables = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
};


export type CurrentBoxtypesQuery = (
  { __typename?: 'Query' }
  & { getBoxTypes?: Maybe<(
    { __typename?: 'BoxTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeDTO' }
      & Pick<BoxTypeDto, 'uuid' | 'name' | 'isValid' | 'isActive'>
      & { inner?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetCurrentBoxTypeQueryVariables = {
  id?: Maybe<Scalars['String']>;
};


export type GetCurrentBoxTypeQuery = (
  { __typename?: 'Query' }
  & { getBoxType?: Maybe<(
    { __typename?: 'BoxTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeDTO' }
      & Pick<BoxTypeDto, 'uuid' | 'name' | 'isValid' | 'isActive'>
      & { inner?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )>, outer?: Maybe<(
        { __typename?: 'BoxTypeSize' }
        & Pick<BoxTypeSize, 'width' | 'height' | 'depth'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type ZonesQueryVariables = {
  q?: Maybe<Scalars['String']>;
};


export type ZonesQuery = (
  { __typename?: 'Query' }
  & { getZones?: Maybe<(
    { __typename?: 'GenericDTOResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'GenericDTO' }
      & Pick<GenericDto, 'uuid' | 'value'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'size' | 'count' | 'offset'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type RacksQueryVariables = {
  zone?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
};


export type RacksQuery = (
  { __typename?: 'Query' }
  & { getRacksPerZone?: Maybe<(
    { __typename?: 'GenericDTOResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'GenericDTO' }
      & Pick<GenericDto, 'uuid' | 'value'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'size' | 'count' | 'offset'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type StorageConfigPerZoneQueryVariables = {
  zone?: Maybe<Scalars['String']>;
};


export type StorageConfigPerZoneQuery = (
  { __typename?: 'Query' }
  & { getStorageConfigPerZone?: Maybe<(
    { __typename?: 'StorageConfigResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'StorageConfigDTO' }
      & Pick<StorageConfigDto, 'uuid' | 'zone'>
      & { currentPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'name' | 'distance'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'size' | 'offset' | 'count'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type CalculateEfficiencyNumberMutationVariables = {
  config?: Maybe<EfficiencyNumberPerRackParamsDto>;
};


export type CalculateEfficiencyNumberMutation = (
  { __typename?: 'Mutation' }
  & { calculateEfficiencyNumber?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type ResetTenantMutationVariables = {};


export type ResetTenantMutation = (
  { __typename?: 'Mutation' }
  & { resetTenant?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type CalculateCurrentFuelLevelsMutationVariables = {};


export type CalculateCurrentFuelLevelsMutation = (
  { __typename?: 'Mutation' }
  & { calculateCurrentFuelLevels?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetMaterialsQueryVariables = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type GetMaterialsQuery = (
  { __typename?: 'Query' }
  & { getMaterials?: Maybe<(
    { __typename?: 'MaterialResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'MaterialDTO' }
      & Pick<MaterialDto, 'uuid' | 'number' | 'description' | 'isActive' | 'mrpType' | 'storageBin' | 'customerGroup'>
      & { packageType?: Maybe<(
        { __typename?: 'PackageTypeDTO' }
        & Pick<PackageTypeDto, 'name'>
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetBoxTypeStatsForBoxTypeMetricQueryVariables = {};


export type GetBoxTypeStatsForBoxTypeMetricQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { boxTypeStat?: Maybe<(
      { __typename?: 'BoxTypeStatDTO' }
      & Pick<BoxTypeStatDto, 'count' | 'active' | 'valid'>
    )> }
  )> }
);

export type GetMaterialStatsForInvalidMaterialMetricQueryVariables = {};


export type GetMaterialStatsForInvalidMaterialMetricQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { materialStat?: Maybe<(
      { __typename?: 'MaterialStatDTO' }
      & Pick<MaterialStatDto, 'invalid' | 'all'>
    )> }
  )> }
);

export type GetMaterialStatsForMaterialMetricQueryVariables = {};


export type GetMaterialStatsForMaterialMetricQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { materialStat?: Maybe<(
      { __typename?: 'MaterialStatDTO' }
      & Pick<MaterialStatDto, 'count' | 'inActive' | 'hasPlace' | 'needToBePlaced'>
    )> }
  )> }
);

export type GetStatsForPackageTypeMetricQueryVariables = {};


export type GetStatsForPackageTypeMetricQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { packageTypeStat?: Maybe<(
      { __typename?: 'PackageTypeStatDTO' }
      & Pick<PackageTypeStatDto, 'count' | 'valid'>
    )> }
  )> }
);

export type GetStorageConfigMetricQueryVariables = {};


export type GetStorageConfigMetricQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { storageConfigStat?: Maybe<(
      { __typename?: 'StorageConfigStatDTO' }
      & Pick<StorageConfigStatDto, 'count' | 'valid'>
    )> }
  )> }
);

export type CurrentAggregateBoxTypesQueryVariables = {};


export type CurrentAggregateBoxTypesQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { aggregateBoxTypes?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeAggregateDTO' }
      & Pick<BoxTypeAggregateDto, 'count'>
      & { boxType?: Maybe<(
        { __typename?: 'BoxTypeDTO' }
        & Pick<BoxTypeDto, 'uuid' | 'name'>
      )> }
    )>>> }
  )> }
);

export type OptimizeBoxFuelLevelsMutationVariables = {
  fuelLevel: Scalars['Float'];
  availableBoxes?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type OptimizeBoxFuelLevelsMutation = (
  { __typename?: 'Mutation' }
  & { optimizeBoxFuelLevels?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type CalculateBestBoxTypesQueryVariables = {
  options: BestBoxTypesOptCalcDto;
};


export type CalculateBestBoxTypesQuery = (
  { __typename?: 'Query' }
  & { getBestBoxTypesForStorageEntriesAgg?: Maybe<(
    { __typename?: 'BestBoxTypesOptAggResultResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BestBoxTypesOptAggResultDTO' }
      & { agg?: Maybe<Array<Maybe<(
        { __typename?: 'BestBoxTypesAggDTO' }
        & Pick<BestBoxTypesAggDto, 'amount'>
        & { boxType?: Maybe<(
          { __typename?: 'BoxTypeDTO' }
          & Pick<BoxTypeDto, 'name'>
        )> }
      )>>> }
    )>>> }
  )> }
);

export type AvgFuelStatQueryVariables = {};


export type AvgFuelStatQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { fuelLevelStat?: Maybe<(
      { __typename?: 'FuelLevelStatDTO' }
      & Pick<FuelLevelStatDto, 'avg'>
    )> }
  )> }
);

export type CurrentAvailableBoxTypesQueryVariables = {};


export type CurrentAvailableBoxTypesQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { aggregateAvailableBoxTypes?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeAggregateDTO' }
      & Pick<BoxTypeAggregateDto, 'count'>
      & { boxType?: Maybe<(
        { __typename?: 'BoxTypeDTO' }
        & Pick<BoxTypeDto, 'uuid' | 'name'>
      )> }
    )>>> }
  )> }
);

export type CalculateNeededBoxesAdvancedMutationVariables = {
  fillingLevel: Scalars['Float'];
  selectedBoxes?: Maybe<Array<Maybe<SelectedBoxDto>>>;
};


export type CalculateNeededBoxesAdvancedMutation = (
  { __typename?: 'Mutation' }
  & { calculateNeededBoxes?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type OptimizeStorageLocationsForZonesMutationVariables = {
  zones?: Maybe<Array<Maybe<Scalars['String']>>>;
  fillingLevel: Scalars['Float'];
  withFilling?: Maybe<Scalars['Boolean']>;
  trendFactor?: Maybe<Scalars['Float']>;
  maxBoxSkip?: Maybe<Scalars['Int']>;
};


export type OptimizeStorageLocationsForZonesMutation = (
  { __typename?: 'Mutation' }
  & { optimizeStorageLocationsForZones?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type CurrentPackagetypesQueryVariables = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type CurrentPackagetypesQuery = (
  { __typename?: 'Query' }
  & { getPackageTypes?: Maybe<(
    { __typename?: 'PackageTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'PackageTypeDTO' }
      & Pick<PackageTypeDto, 'uuid' | 'name' | 'width' | 'height' | 'depth' | 'volume' | 'isValid'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetPickZonesQueryVariables = {
  pagination?: Maybe<PageableParam>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
};


export type GetPickZonesQuery = (
  { __typename?: 'Query' }
  & { getPickZones?: Maybe<(
    { __typename?: 'PickZoneResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'PickZoneDTO' }
      & Pick<PickZoneDto, 'uuid' | 'name'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetTenantsQueryVariables = {
  q?: Maybe<Scalars['String']>;
};


export type GetTenantsQuery = (
  { __typename?: 'Query' }
  & { getTenants?: Maybe<(
    { __typename?: 'TenantResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'TenantDTO' }
      & Pick<TenantDto, 'uuid' | 'name'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type DeleteStorageConfigsMutationVariables = {
  id?: Maybe<Scalars['String']>;
};


export type DeleteStorageConfigsMutation = (
  { __typename?: 'Mutation' }
  & { deleteStorageConfig?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type DeleteUnusedStorageConfigsMutationVariables = {};


export type DeleteUnusedStorageConfigsMutation = (
  { __typename?: 'Mutation' }
  & { deleteUnusedStorageConfigs?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type GetCustomerGroupsQueryVariables = {
  q?: Maybe<Scalars['String']>;
};


export type GetCustomerGroupsQuery = (
  { __typename?: 'Query' }
  & { getCustomerGroups?: Maybe<(
    { __typename?: 'GenericDTOResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'GenericDTO' }
      & Pick<GenericDto, 'uuid' | 'value'>
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type CurrentStorageconfigsQueryVariables = {
  pagination?: Maybe<PageableParam>;
};


export type CurrentStorageconfigsQuery = (
  { __typename?: 'Query' }
  & { getStorageConfigs?: Maybe<(
    { __typename?: 'StorageConfigResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'StorageConfigDTO' }
      & Pick<StorageConfigDto, 'uuid' | 'zoneEffFactor' | 'customerGroups' | 'effCalcDone' | 'zone' | 'isFlowRackZone' | 'bestPosition'>
      & { currentPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'name' | 'next' | 'distance'>
      )>, estimatedPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'distance'>
      )>, racks?: Maybe<Array<Maybe<(
        { __typename?: 'RackConfigDTO' }
        & Pick<RackConfigDto, 'name' | 'count'>
      )>>>, flowRackBoxes?: Maybe<Array<Maybe<(
        { __typename?: 'FlowRackBoxDTO' }
        & Pick<FlowRackBoxDto, 'count'>
        & { box?: Maybe<(
          { __typename?: 'BoxTypeDTO' }
          & Pick<BoxTypeDto, 'name'>
        )> }
      )>>> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetCurrentStorageconfigQueryVariables = {
  id?: Maybe<Scalars['String']>;
};


export type GetCurrentStorageconfigQuery = (
  { __typename?: 'Query' }
  & { getStorageConfig?: Maybe<(
    { __typename?: 'StorageConfigResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'StorageConfigDTO' }
      & Pick<StorageConfigDto, 'uuid' | 'zone' | 'zoneEffFactor' | 'bestPosition' | 'customerGroups' | 'isFlowRackZone'>
      & { racks?: Maybe<Array<Maybe<(
        { __typename?: 'RackConfigDTO' }
        & Pick<RackConfigDto, 'name' | 'count'>
      )>>>, currentPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'name' | 'distance'>
      )>, estimatedPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'name' | 'distance'>
      )>, flowRackBoxes?: Maybe<Array<Maybe<(
        { __typename?: 'FlowRackBoxDTO' }
        & Pick<FlowRackBoxDto, 'count'>
        & { box?: Maybe<(
          { __typename?: 'BoxTypeDTO' }
          & Pick<BoxTypeDto, 'uuid' | 'name'>
        )> }
      )>>> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'count' | 'offset' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type GetBoxesPerRackQueryVariables = {
  zone: Scalars['String'];
};


export type GetBoxesPerRackQuery = (
  { __typename?: 'Query' }
  & { getBoxesPerZone?: Maybe<(
    { __typename?: 'BoxTypeResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeDTO' }
      & Pick<BoxTypeDto, 'uuid' | 'name'>
    )>>>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type AssignTenantMutationVariables = {
  userId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type AssignTenantMutation = (
  { __typename?: 'Mutation' }
  & { assignTenant?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'code' | 'message'>
    )> }
  )> }
);

export type UpdateStorageConfigQueryMutationVariables = {
  id: Scalars['String'];
  config: StorageConfigUpdateInput;
};


export type UpdateStorageConfigQueryMutation = (
  { __typename?: 'Mutation' }
  & { updateStorageConfig?: Maybe<(
    { __typename?: 'StorageConfigResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'StorageConfigDTO' }
      & Pick<StorageConfigDto, 'uuid' | 'zone' | 'bestPosition' | 'effCalcDone' | 'zoneEffFactor' | 'customerGroups' | 'isFlowRackZone'>
      & { currentPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'distance'>
      )>, estimatedPickZone?: Maybe<(
        { __typename?: 'StorageConfigZonePickZoneDTO' }
        & Pick<StorageConfigZonePickZoneDto, 'next' | 'distance'>
      )>, flowRackBoxes?: Maybe<Array<Maybe<(
        { __typename?: 'FlowRackBoxDTO' }
        & Pick<FlowRackBoxDto, 'count'>
        & { box?: Maybe<(
          { __typename?: 'BoxTypeDTO' }
          & Pick<BoxTypeDto, 'name'>
        )> }
      )>>> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'offset' | 'count' | 'size'>
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type GetMeQueryVariables = {};


export type GetMeQuery = (
  { __typename?: 'Query' }
  & { getMe?: Maybe<(
    { __typename?: 'UserResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'UserDTO' }
      & Pick<UserDto, 'uuid' | 'name' | 'surname' | 'department' | 'email' | 'roles'>
      & { tenant?: Maybe<(
        { __typename?: 'TenantDTO' }
        & Pick<TenantDto, 'uuid' | 'name'>
        & { config?: Maybe<(
          { __typename?: 'TenantConfigDTO' }
          & Pick<TenantConfigDto, 'desiredFuelLevel'>
          & { storageLocationConfig?: Maybe<(
            { __typename?: 'TenantStorageLocationConfig' }
            & Pick<TenantStorageLocationConfig, 'zone' | 'rack' | 'level' | 'position' | 'section'>
          )>, efficiencyCalcSetting?: Maybe<(
            { __typename?: 'TenantEfficiencyCalcSettingDTO' }
            & Pick<TenantEfficiencyCalcSettingDto, 'verticalUp' | 'verticalDown' | 'horizontal'>
          )> }
        )> }
      )> }
    )>>> }
  )> }
);

export type GetProcessLogsQueryVariables = {
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type GetProcessLogsQuery = (
  { __typename?: 'Query' }
  & { getProcessLogs?: Maybe<(
    { __typename?: 'ProcessLogResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'ProcessLogDTO' }
      & Pick<ProcessLogDto, 'uuid' | 'start' | 'status' | 'meta' | 'message' | 'type'>
      & { meta2?: Maybe<(
        { __typename?: 'ProcessLogMetaDTO' }
        & { params?: Maybe<Array<Maybe<(
          { __typename?: 'ProcessLogMetaParamDTO' }
          & Pick<ProcessLogMetaParamDto, 'name' | 'value' | 'type'>
        )>>>, result?: Maybe<Array<Maybe<(
          { __typename?: 'ProcessLogMetaParamDTO' }
          & Pick<ProcessLogMetaParamDto, 'name' | 'value' | 'type'>
        )>>> }
      )> }
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'size' | 'offset' | 'count'>
    )> }
  )> }
);

export type UpdateTenantMutationVariables = {
  id?: Maybe<Scalars['String']>;
  tenant?: Maybe<TenantInput>;
};


export type UpdateTenantMutation = (
  { __typename?: 'Mutation' }
  & { updateTenant?: Maybe<(
    { __typename?: 'TenantResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'TenantDTO' }
      & Pick<TenantDto, 'name'>
      & { config?: Maybe<(
        { __typename?: 'TenantConfigDTO' }
        & Pick<TenantConfigDto, 'desiredFuelLevel'>
        & { storageLocationConfig?: Maybe<(
          { __typename?: 'TenantStorageLocationConfig' }
          & Pick<TenantStorageLocationConfig, 'zone'>
        )>, efficiencyCalcSetting?: Maybe<(
          { __typename?: 'TenantEfficiencyCalcSettingDTO' }
          & Pick<TenantEfficiencyCalcSettingDto, 'verticalUp'>
        )> }
      )> }
    )>>>, error?: Maybe<(
      { __typename?: 'Error' }
      & ErrorPartsFragment
    )> }
  )> }
);

export type GetTenantQueryVariables = {
  id?: Maybe<Scalars['String']>;
};


export type GetTenantQuery = (
  { __typename?: 'Query' }
  & { getTenant?: Maybe<(
    { __typename?: 'TenantResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'TenantDTO' }
      & Pick<TenantDto, 'uuid' | 'name'>
      & { config?: Maybe<(
        { __typename?: 'TenantConfigDTO' }
        & Pick<TenantConfigDto, 'desiredFuelLevel'>
        & { storageLocationConfig?: Maybe<(
          { __typename?: 'TenantStorageLocationConfig' }
          & Pick<TenantStorageLocationConfig, 'zone' | 'rack' | 'level' | 'position' | 'section'>
        )>, efficiencyCalcSetting?: Maybe<(
          { __typename?: 'TenantEfficiencyCalcSettingDTO' }
          & Pick<TenantEfficiencyCalcSettingDto, 'verticalUp' | 'verticalDown' | 'horizontal'>
        )> }
      )> }
    )>>>, error?: Maybe<(
      { __typename?: 'Error' }
      & ErrorPartsFragment
    )> }
  )> }
);

export type MetaDtoPartsFragment = (
  { __typename?: 'PageInfo' }
  & Pick<PageInfo, 'offset' | 'count' | 'size'>
);

export type ErrorPartsFragment = (
  { __typename?: 'Error' }
  & Pick<Error, 'message' | 'code'>
);

export type FuelLevelStatQueryQueryVariables = {};


export type FuelLevelStatQueryQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { fuelLevelStat?: Maybe<(
      { __typename?: 'FuelLevelStatDTO' }
      & Pick<FuelLevelStatDto, 'avg' | 'amountOfInvalidFuelLevel' | 'amountWithFuelLevel'>
    )> }
  )> }
);

export type GetStatisticsQueryVariables = {};


export type GetStatisticsQuery = (
  { __typename?: 'Query' }
  & { getStatistics?: Maybe<(
    { __typename?: 'StatisticDTO' }
    & { packageTypeStat?: Maybe<(
      { __typename?: 'PackageTypeStatDTO' }
      & Pick<PackageTypeStatDto, 'count' | 'valid'>
    )>, boxTypeStat?: Maybe<(
      { __typename?: 'BoxTypeStatDTO' }
      & Pick<BoxTypeStatDto, 'count' | 'active' | 'valid'>
    )>, storageStructureStat?: Maybe<(
      { __typename?: 'StorageStructureStatDTO' }
      & Pick<StorageStructureStatDto, 'pickZones' | 'zones' | 'racks' | 'levels' | 'positions' | 'sections' | 'customerGroups'>
    )>, storageEntryStat?: Maybe<(
      { __typename?: 'StorageEntryStatDTO' }
      & Pick<StorageEntryStatDto, 'count' | 'reserved' | 'inUse' | 'free'>
    )>, aggregateBoxTypes?: Maybe<Array<Maybe<(
      { __typename?: 'BoxTypeAggregateDTO' }
      & Pick<BoxTypeAggregateDto, 'count'>
      & { boxType?: Maybe<(
        { __typename?: 'BoxTypeDTO' }
        & Pick<BoxTypeDto, 'uuid' | 'name' | 'isValid' | 'isActive'>
      )> }
    )>>> }
  )> }
);

export type ImportMaterialsMutationVariables = {};


export type ImportMaterialsMutation = (
  { __typename?: 'Mutation' }
  & { importMaterials?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type ImportPackageTypesMutationVariables = {};


export type ImportPackageTypesMutation = (
  { __typename?: 'Mutation' }
  & { importPackageTypes?: Maybe<(
    { __typename?: 'ExecutionResultResource' }
    & Pick<ExecutionResultResource, 'success'>
    & { error?: Maybe<(
      { __typename?: 'Error' }
      & Pick<Error, 'message' | 'code'>
    )> }
  )> }
);

export type StorageEntryPartsFragment = (
  { __typename?: 'StorageEntryDTO' }
  & Pick<StorageEntryDto, 'uuid' | 'zone' | 'rack' | 'level' | 'position' | 'section' | 'effNumber' | 'fuelLevel' | 'direction' | 'currentStock' | 'maxStock' | 'avg3Month' | 'avg12Month' | 'isOverflow'>
  & { boxType?: Maybe<(
    { __typename?: 'BoxTypeDTO' }
    & Pick<BoxTypeDto, 'name'>
  )>, material?: Maybe<(
    { __typename?: 'MaterialDTO' }
    & Pick<MaterialDto, 'number' | 'description' | 'customerGroup'>
  )> }
);

export type StorageEntriesQueryVariables = {
  pagination?: Maybe<PageableParam>;
  sort?: Maybe<Array<Maybe<SortParam>>>;
  filter?: Maybe<Array<Maybe<FilterParam>>>;
  q?: Maybe<Scalars['String']>;
};


export type StorageEntriesQuery = (
  { __typename?: 'Query' }
  & { getEntries?: Maybe<(
    { __typename?: 'StorageEntryResourceList' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'StorageEntryDTO' }
      & StorageEntryPartsFragment
    )>>>, meta?: Maybe<(
      { __typename?: 'PageInfo' }
      & MetaDtoPartsFragment
    )>, error?: Maybe<(
      { __typename?: 'Error' }
      & ErrorPartsFragment
    )> }
  )> }
);

export const MetaDtoPartsFragmentDoc = gql`
    fragment MetaDTOParts on PageInfo {
  offset
  count
  size
}
    `;
export const ErrorPartsFragmentDoc = gql`
    fragment ErrorParts on Error {
  message
  code
}
    `;
export const StorageEntryPartsFragmentDoc = gql`
    fragment StorageEntryParts on StorageEntryDTO {
  uuid
  zone
  rack
  level
  position
  section
  effNumber
  fuelLevel
  direction
  currentStock
  maxStock
  avg3Month
  avg12Month
  isOverflow
  boxType {
    name
  }
  material {
    number
    description
    customerGroup
  }
}
    `;
export const AddBoxTypeDocument = gql`
    mutation addBoxType($boxType: BoxTypeCreateInput) {
  addBoxType(boxType: $boxType) {
    data {
      uuid
      name
      inner {
        width
        height
        depth
      }
      outer {
        width
        height
        depth
      }
      isValid
      isActive
    }
    meta {
      offset
      count
      size
    }
    error {
      message
      code
    }
  }
}
    `;
export type AddBoxTypeMutationFn = ApolloReactCommon.MutationFunction<AddBoxTypeMutation, AddBoxTypeMutationVariables>;

/**
 * __useAddBoxTypeMutation__
 *
 * To run a mutation, you first call `useAddBoxTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBoxTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBoxTypeMutation, { data, loading, error }] = useAddBoxTypeMutation({
 *   variables: {
 *      boxType: // value for 'boxType'
 *   },
 * });
 */
export function useAddBoxTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBoxTypeMutation, AddBoxTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<AddBoxTypeMutation, AddBoxTypeMutationVariables>(AddBoxTypeDocument, baseOptions);
      }
export type AddBoxTypeMutationHookResult = ReturnType<typeof useAddBoxTypeMutation>;
export type AddBoxTypeMutationResult = ApolloReactCommon.MutationResult<AddBoxTypeMutation>;
export type AddBoxTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<AddBoxTypeMutation, AddBoxTypeMutationVariables>;
export const UpdateBoxTypeDocument = gql`
    mutation updateBoxType($id: String, $boxType: BoxTypeUpdateInput) {
  updateBoxType(id: $id, boxType: $boxType) {
    data {
      uuid
      name
      inner {
        width
        height
        depth
      }
      outer {
        width
        height
        depth
      }
      isValid
      isActive
    }
    meta {
      offset
      count
      size
    }
    error {
      message
      code
    }
  }
}
    `;
export type UpdateBoxTypeMutationFn = ApolloReactCommon.MutationFunction<UpdateBoxTypeMutation, UpdateBoxTypeMutationVariables>;

/**
 * __useUpdateBoxTypeMutation__
 *
 * To run a mutation, you first call `useUpdateBoxTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoxTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoxTypeMutation, { data, loading, error }] = useUpdateBoxTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      boxType: // value for 'boxType'
 *   },
 * });
 */
export function useUpdateBoxTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBoxTypeMutation, UpdateBoxTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBoxTypeMutation, UpdateBoxTypeMutationVariables>(UpdateBoxTypeDocument, baseOptions);
      }
export type UpdateBoxTypeMutationHookResult = ReturnType<typeof useUpdateBoxTypeMutation>;
export type UpdateBoxTypeMutationResult = ApolloReactCommon.MutationResult<UpdateBoxTypeMutation>;
export type UpdateBoxTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBoxTypeMutation, UpdateBoxTypeMutationVariables>;
export const DeleteBoxTypeDocument = gql`
    mutation deleteBoxType($id: String) {
  deleteBoxType(id: $id) {
    success
    error {
      message
      code
    }
  }
}
    `;
export type DeleteBoxTypeMutationFn = ApolloReactCommon.MutationFunction<DeleteBoxTypeMutation, DeleteBoxTypeMutationVariables>;

/**
 * __useDeleteBoxTypeMutation__
 *
 * To run a mutation, you first call `useDeleteBoxTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoxTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoxTypeMutation, { data, loading, error }] = useDeleteBoxTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBoxTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBoxTypeMutation, DeleteBoxTypeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBoxTypeMutation, DeleteBoxTypeMutationVariables>(DeleteBoxTypeDocument, baseOptions);
      }
export type DeleteBoxTypeMutationHookResult = ReturnType<typeof useDeleteBoxTypeMutation>;
export type DeleteBoxTypeMutationResult = ApolloReactCommon.MutationResult<DeleteBoxTypeMutation>;
export type DeleteBoxTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBoxTypeMutation, DeleteBoxTypeMutationVariables>;
export const CurrentBoxtypesDocument = gql`
    query currentBoxtypes($pagination: PageableParam, $sort: [SortParam], $filter: [FilterParam]) {
  getBoxTypes(pagination: $pagination, sort: $sort, filter: $filter) {
    data {
      uuid
      name
      inner {
        width
        height
        depth
      }
      isValid
      isActive
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useCurrentBoxtypesQuery__
 *
 * To run a query within a React component, call `useCurrentBoxtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBoxtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBoxtypesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCurrentBoxtypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentBoxtypesQuery, CurrentBoxtypesQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentBoxtypesQuery, CurrentBoxtypesQueryVariables>(CurrentBoxtypesDocument, baseOptions);
      }
export function useCurrentBoxtypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBoxtypesQuery, CurrentBoxtypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentBoxtypesQuery, CurrentBoxtypesQueryVariables>(CurrentBoxtypesDocument, baseOptions);
        }
export type CurrentBoxtypesQueryHookResult = ReturnType<typeof useCurrentBoxtypesQuery>;
export type CurrentBoxtypesLazyQueryHookResult = ReturnType<typeof useCurrentBoxtypesLazyQuery>;
export type CurrentBoxtypesQueryResult = ApolloReactCommon.QueryResult<CurrentBoxtypesQuery, CurrentBoxtypesQueryVariables>;
export const GetCurrentBoxTypeDocument = gql`
    query getCurrentBoxType($id: String) {
  getBoxType(id: $id) {
    data {
      uuid
      name
      inner {
        width
        height
        depth
      }
      outer {
        width
        height
        depth
      }
      isValid
      isActive
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetCurrentBoxTypeQuery__
 *
 * To run a query within a React component, call `useGetCurrentBoxTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBoxTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBoxTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentBoxTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentBoxTypeQuery, GetCurrentBoxTypeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrentBoxTypeQuery, GetCurrentBoxTypeQueryVariables>(GetCurrentBoxTypeDocument, baseOptions);
      }
export function useGetCurrentBoxTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentBoxTypeQuery, GetCurrentBoxTypeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrentBoxTypeQuery, GetCurrentBoxTypeQueryVariables>(GetCurrentBoxTypeDocument, baseOptions);
        }
export type GetCurrentBoxTypeQueryHookResult = ReturnType<typeof useGetCurrentBoxTypeQuery>;
export type GetCurrentBoxTypeLazyQueryHookResult = ReturnType<typeof useGetCurrentBoxTypeLazyQuery>;
export type GetCurrentBoxTypeQueryResult = ApolloReactCommon.QueryResult<GetCurrentBoxTypeQuery, GetCurrentBoxTypeQueryVariables>;
export const ZonesDocument = gql`
    query zones($q: String) {
  getZones(q: $q) {
    data {
      uuid
      value
    }
    meta {
      size
      count
      offset
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useZonesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
        return ApolloReactHooks.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, baseOptions);
      }
export function useZonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, baseOptions);
        }
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesQueryResult = ApolloReactCommon.QueryResult<ZonesQuery, ZonesQueryVariables>;
export const RacksDocument = gql`
    query racks($zone: String, $q: String) {
  getRacksPerZone(zone: $zone, q: $q) {
    data {
      uuid
      value
    }
    meta {
      size
      count
      offset
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useRacksQuery__
 *
 * To run a query within a React component, call `useRacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRacksQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRacksQuery({
 *   variables: {
 *      zone: // value for 'zone'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useRacksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RacksQuery, RacksQueryVariables>) {
        return ApolloReactHooks.useQuery<RacksQuery, RacksQueryVariables>(RacksDocument, baseOptions);
      }
export function useRacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RacksQuery, RacksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RacksQuery, RacksQueryVariables>(RacksDocument, baseOptions);
        }
export type RacksQueryHookResult = ReturnType<typeof useRacksQuery>;
export type RacksLazyQueryHookResult = ReturnType<typeof useRacksLazyQuery>;
export type RacksQueryResult = ApolloReactCommon.QueryResult<RacksQuery, RacksQueryVariables>;
export const StorageConfigPerZoneDocument = gql`
    query storageConfigPerZone($zone: String) {
  getStorageConfigPerZone(zone: $zone) {
    data {
      uuid
      zone
      currentPickZone {
        next
        name
        distance
      }
    }
    meta {
      size
      offset
      count
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useStorageConfigPerZoneQuery__
 *
 * To run a query within a React component, call `useStorageConfigPerZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageConfigPerZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageConfigPerZoneQuery({
 *   variables: {
 *      zone: // value for 'zone'
 *   },
 * });
 */
export function useStorageConfigPerZoneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorageConfigPerZoneQuery, StorageConfigPerZoneQueryVariables>) {
        return ApolloReactHooks.useQuery<StorageConfigPerZoneQuery, StorageConfigPerZoneQueryVariables>(StorageConfigPerZoneDocument, baseOptions);
      }
export function useStorageConfigPerZoneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageConfigPerZoneQuery, StorageConfigPerZoneQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StorageConfigPerZoneQuery, StorageConfigPerZoneQueryVariables>(StorageConfigPerZoneDocument, baseOptions);
        }
export type StorageConfigPerZoneQueryHookResult = ReturnType<typeof useStorageConfigPerZoneQuery>;
export type StorageConfigPerZoneLazyQueryHookResult = ReturnType<typeof useStorageConfigPerZoneLazyQuery>;
export type StorageConfigPerZoneQueryResult = ApolloReactCommon.QueryResult<StorageConfigPerZoneQuery, StorageConfigPerZoneQueryVariables>;
export const CalculateEfficiencyNumberDocument = gql`
    mutation calculateEfficiencyNumber($config: EfficiencyNumberPerRackParamsDTO) {
  calculateEfficiencyNumber(config: $config) {
    success
    error {
      code
      message
    }
  }
}
    `;
export type CalculateEfficiencyNumberMutationFn = ApolloReactCommon.MutationFunction<CalculateEfficiencyNumberMutation, CalculateEfficiencyNumberMutationVariables>;

/**
 * __useCalculateEfficiencyNumberMutation__
 *
 * To run a mutation, you first call `useCalculateEfficiencyNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateEfficiencyNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateEfficiencyNumberMutation, { data, loading, error }] = useCalculateEfficiencyNumberMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useCalculateEfficiencyNumberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateEfficiencyNumberMutation, CalculateEfficiencyNumberMutationVariables>) {
        return ApolloReactHooks.useMutation<CalculateEfficiencyNumberMutation, CalculateEfficiencyNumberMutationVariables>(CalculateEfficiencyNumberDocument, baseOptions);
      }
export type CalculateEfficiencyNumberMutationHookResult = ReturnType<typeof useCalculateEfficiencyNumberMutation>;
export type CalculateEfficiencyNumberMutationResult = ApolloReactCommon.MutationResult<CalculateEfficiencyNumberMutation>;
export type CalculateEfficiencyNumberMutationOptions = ApolloReactCommon.BaseMutationOptions<CalculateEfficiencyNumberMutation, CalculateEfficiencyNumberMutationVariables>;
export const ResetTenantDocument = gql`
    mutation resetTenant {
  resetTenant {
    success
    error {
      code
      message
    }
  }
}
    `;
export type ResetTenantMutationFn = ApolloReactCommon.MutationFunction<ResetTenantMutation, ResetTenantMutationVariables>;

/**
 * __useResetTenantMutation__
 *
 * To run a mutation, you first call `useResetTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetTenantMutation, { data, loading, error }] = useResetTenantMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetTenantMutation, ResetTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<ResetTenantMutation, ResetTenantMutationVariables>(ResetTenantDocument, baseOptions);
      }
export type ResetTenantMutationHookResult = ReturnType<typeof useResetTenantMutation>;
export type ResetTenantMutationResult = ApolloReactCommon.MutationResult<ResetTenantMutation>;
export type ResetTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetTenantMutation, ResetTenantMutationVariables>;
export const CalculateCurrentFuelLevelsDocument = gql`
    mutation calculateCurrentFuelLevels {
  calculateCurrentFuelLevels {
    success
    error {
      code
      message
    }
  }
}
    `;
export type CalculateCurrentFuelLevelsMutationFn = ApolloReactCommon.MutationFunction<CalculateCurrentFuelLevelsMutation, CalculateCurrentFuelLevelsMutationVariables>;

/**
 * __useCalculateCurrentFuelLevelsMutation__
 *
 * To run a mutation, you first call `useCalculateCurrentFuelLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateCurrentFuelLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateCurrentFuelLevelsMutation, { data, loading, error }] = useCalculateCurrentFuelLevelsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCalculateCurrentFuelLevelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateCurrentFuelLevelsMutation, CalculateCurrentFuelLevelsMutationVariables>) {
        return ApolloReactHooks.useMutation<CalculateCurrentFuelLevelsMutation, CalculateCurrentFuelLevelsMutationVariables>(CalculateCurrentFuelLevelsDocument, baseOptions);
      }
export type CalculateCurrentFuelLevelsMutationHookResult = ReturnType<typeof useCalculateCurrentFuelLevelsMutation>;
export type CalculateCurrentFuelLevelsMutationResult = ApolloReactCommon.MutationResult<CalculateCurrentFuelLevelsMutation>;
export type CalculateCurrentFuelLevelsMutationOptions = ApolloReactCommon.BaseMutationOptions<CalculateCurrentFuelLevelsMutation, CalculateCurrentFuelLevelsMutationVariables>;
export const GetMaterialsDocument = gql`
    query getMaterials($pagination: PageableParam, $sort: [SortParam], $filter: [FilterParam], $q: String) {
  getMaterials(pagination: $pagination, sort: $sort, q: $q, filter: $filter) {
    data {
      uuid
      number
      description
      isActive
      mrpType
      storageBin
      customerGroup
      packageType {
        name
      }
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetMaterialsQuery__
 *
 * To run a query within a React component, call `useGetMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetMaterialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMaterialsQuery, GetMaterialsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMaterialsQuery, GetMaterialsQueryVariables>(GetMaterialsDocument, baseOptions);
      }
export function useGetMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaterialsQuery, GetMaterialsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMaterialsQuery, GetMaterialsQueryVariables>(GetMaterialsDocument, baseOptions);
        }
export type GetMaterialsQueryHookResult = ReturnType<typeof useGetMaterialsQuery>;
export type GetMaterialsLazyQueryHookResult = ReturnType<typeof useGetMaterialsLazyQuery>;
export type GetMaterialsQueryResult = ApolloReactCommon.QueryResult<GetMaterialsQuery, GetMaterialsQueryVariables>;
export const GetBoxTypeStatsForBoxTypeMetricDocument = gql`
    query getBoxTypeStatsForBoxTypeMetric {
  getStatistics {
    boxTypeStat {
      count
      active
      valid
    }
  }
}
    `;

/**
 * __useGetBoxTypeStatsForBoxTypeMetricQuery__
 *
 * To run a query within a React component, call `useGetBoxTypeStatsForBoxTypeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxTypeStatsForBoxTypeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxTypeStatsForBoxTypeMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBoxTypeStatsForBoxTypeMetricQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoxTypeStatsForBoxTypeMetricQuery, GetBoxTypeStatsForBoxTypeMetricQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoxTypeStatsForBoxTypeMetricQuery, GetBoxTypeStatsForBoxTypeMetricQueryVariables>(GetBoxTypeStatsForBoxTypeMetricDocument, baseOptions);
      }
export function useGetBoxTypeStatsForBoxTypeMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoxTypeStatsForBoxTypeMetricQuery, GetBoxTypeStatsForBoxTypeMetricQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoxTypeStatsForBoxTypeMetricQuery, GetBoxTypeStatsForBoxTypeMetricQueryVariables>(GetBoxTypeStatsForBoxTypeMetricDocument, baseOptions);
        }
export type GetBoxTypeStatsForBoxTypeMetricQueryHookResult = ReturnType<typeof useGetBoxTypeStatsForBoxTypeMetricQuery>;
export type GetBoxTypeStatsForBoxTypeMetricLazyQueryHookResult = ReturnType<typeof useGetBoxTypeStatsForBoxTypeMetricLazyQuery>;
export type GetBoxTypeStatsForBoxTypeMetricQueryResult = ApolloReactCommon.QueryResult<GetBoxTypeStatsForBoxTypeMetricQuery, GetBoxTypeStatsForBoxTypeMetricQueryVariables>;
export const GetMaterialStatsForInvalidMaterialMetricDocument = gql`
    query getMaterialStatsForInvalidMaterialMetric {
  getStatistics {
    materialStat {
      invalid
      all
    }
  }
}
    `;

/**
 * __useGetMaterialStatsForInvalidMaterialMetricQuery__
 *
 * To run a query within a React component, call `useGetMaterialStatsForInvalidMaterialMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStatsForInvalidMaterialMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStatsForInvalidMaterialMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaterialStatsForInvalidMaterialMetricQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMaterialStatsForInvalidMaterialMetricQuery, GetMaterialStatsForInvalidMaterialMetricQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMaterialStatsForInvalidMaterialMetricQuery, GetMaterialStatsForInvalidMaterialMetricQueryVariables>(GetMaterialStatsForInvalidMaterialMetricDocument, baseOptions);
      }
export function useGetMaterialStatsForInvalidMaterialMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaterialStatsForInvalidMaterialMetricQuery, GetMaterialStatsForInvalidMaterialMetricQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMaterialStatsForInvalidMaterialMetricQuery, GetMaterialStatsForInvalidMaterialMetricQueryVariables>(GetMaterialStatsForInvalidMaterialMetricDocument, baseOptions);
        }
export type GetMaterialStatsForInvalidMaterialMetricQueryHookResult = ReturnType<typeof useGetMaterialStatsForInvalidMaterialMetricQuery>;
export type GetMaterialStatsForInvalidMaterialMetricLazyQueryHookResult = ReturnType<typeof useGetMaterialStatsForInvalidMaterialMetricLazyQuery>;
export type GetMaterialStatsForInvalidMaterialMetricQueryResult = ApolloReactCommon.QueryResult<GetMaterialStatsForInvalidMaterialMetricQuery, GetMaterialStatsForInvalidMaterialMetricQueryVariables>;
export const GetMaterialStatsForMaterialMetricDocument = gql`
    query getMaterialStatsForMaterialMetric {
  getStatistics {
    materialStat {
      count
      inActive
      hasPlace
      needToBePlaced
    }
  }
}
    `;

/**
 * __useGetMaterialStatsForMaterialMetricQuery__
 *
 * To run a query within a React component, call `useGetMaterialStatsForMaterialMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStatsForMaterialMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStatsForMaterialMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaterialStatsForMaterialMetricQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMaterialStatsForMaterialMetricQuery, GetMaterialStatsForMaterialMetricQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMaterialStatsForMaterialMetricQuery, GetMaterialStatsForMaterialMetricQueryVariables>(GetMaterialStatsForMaterialMetricDocument, baseOptions);
      }
export function useGetMaterialStatsForMaterialMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMaterialStatsForMaterialMetricQuery, GetMaterialStatsForMaterialMetricQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMaterialStatsForMaterialMetricQuery, GetMaterialStatsForMaterialMetricQueryVariables>(GetMaterialStatsForMaterialMetricDocument, baseOptions);
        }
export type GetMaterialStatsForMaterialMetricQueryHookResult = ReturnType<typeof useGetMaterialStatsForMaterialMetricQuery>;
export type GetMaterialStatsForMaterialMetricLazyQueryHookResult = ReturnType<typeof useGetMaterialStatsForMaterialMetricLazyQuery>;
export type GetMaterialStatsForMaterialMetricQueryResult = ApolloReactCommon.QueryResult<GetMaterialStatsForMaterialMetricQuery, GetMaterialStatsForMaterialMetricQueryVariables>;
export const GetStatsForPackageTypeMetricDocument = gql`
    query getStatsForPackageTypeMetric {
  getStatistics {
    packageTypeStat {
      count
      valid
    }
  }
}
    `;

/**
 * __useGetStatsForPackageTypeMetricQuery__
 *
 * To run a query within a React component, call `useGetStatsForPackageTypeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsForPackageTypeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsForPackageTypeMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatsForPackageTypeMetricQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatsForPackageTypeMetricQuery, GetStatsForPackageTypeMetricQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStatsForPackageTypeMetricQuery, GetStatsForPackageTypeMetricQueryVariables>(GetStatsForPackageTypeMetricDocument, baseOptions);
      }
export function useGetStatsForPackageTypeMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatsForPackageTypeMetricQuery, GetStatsForPackageTypeMetricQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStatsForPackageTypeMetricQuery, GetStatsForPackageTypeMetricQueryVariables>(GetStatsForPackageTypeMetricDocument, baseOptions);
        }
export type GetStatsForPackageTypeMetricQueryHookResult = ReturnType<typeof useGetStatsForPackageTypeMetricQuery>;
export type GetStatsForPackageTypeMetricLazyQueryHookResult = ReturnType<typeof useGetStatsForPackageTypeMetricLazyQuery>;
export type GetStatsForPackageTypeMetricQueryResult = ApolloReactCommon.QueryResult<GetStatsForPackageTypeMetricQuery, GetStatsForPackageTypeMetricQueryVariables>;
export const GetStorageConfigMetricDocument = gql`
    query getStorageConfigMetric {
  getStatistics {
    storageConfigStat {
      count
      valid
    }
  }
}
    `;

/**
 * __useGetStorageConfigMetricQuery__
 *
 * To run a query within a React component, call `useGetStorageConfigMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageConfigMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageConfigMetricQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStorageConfigMetricQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStorageConfigMetricQuery, GetStorageConfigMetricQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStorageConfigMetricQuery, GetStorageConfigMetricQueryVariables>(GetStorageConfigMetricDocument, baseOptions);
      }
export function useGetStorageConfigMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStorageConfigMetricQuery, GetStorageConfigMetricQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStorageConfigMetricQuery, GetStorageConfigMetricQueryVariables>(GetStorageConfigMetricDocument, baseOptions);
        }
export type GetStorageConfigMetricQueryHookResult = ReturnType<typeof useGetStorageConfigMetricQuery>;
export type GetStorageConfigMetricLazyQueryHookResult = ReturnType<typeof useGetStorageConfigMetricLazyQuery>;
export type GetStorageConfigMetricQueryResult = ApolloReactCommon.QueryResult<GetStorageConfigMetricQuery, GetStorageConfigMetricQueryVariables>;
export const CurrentAggregateBoxTypesDocument = gql`
    query currentAggregateBoxTypes {
  getStatistics {
    aggregateBoxTypes {
      count
      boxType {
        uuid
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentAggregateBoxTypesQuery__
 *
 * To run a query within a React component, call `useCurrentAggregateBoxTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAggregateBoxTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAggregateBoxTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAggregateBoxTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentAggregateBoxTypesQuery, CurrentAggregateBoxTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentAggregateBoxTypesQuery, CurrentAggregateBoxTypesQueryVariables>(CurrentAggregateBoxTypesDocument, baseOptions);
      }
export function useCurrentAggregateBoxTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentAggregateBoxTypesQuery, CurrentAggregateBoxTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentAggregateBoxTypesQuery, CurrentAggregateBoxTypesQueryVariables>(CurrentAggregateBoxTypesDocument, baseOptions);
        }
export type CurrentAggregateBoxTypesQueryHookResult = ReturnType<typeof useCurrentAggregateBoxTypesQuery>;
export type CurrentAggregateBoxTypesLazyQueryHookResult = ReturnType<typeof useCurrentAggregateBoxTypesLazyQuery>;
export type CurrentAggregateBoxTypesQueryResult = ApolloReactCommon.QueryResult<CurrentAggregateBoxTypesQuery, CurrentAggregateBoxTypesQueryVariables>;
export const OptimizeBoxFuelLevelsDocument = gql`
    mutation optimizeBoxFuelLevels($fuelLevel: Float!, $availableBoxes: [String]) {
  optimizeBoxFuelLevels(fuelLevel: $fuelLevel, availableBoxes: $availableBoxes) {
    error {
      message
      code
    }
    success
  }
}
    `;
export type OptimizeBoxFuelLevelsMutationFn = ApolloReactCommon.MutationFunction<OptimizeBoxFuelLevelsMutation, OptimizeBoxFuelLevelsMutationVariables>;

/**
 * __useOptimizeBoxFuelLevelsMutation__
 *
 * To run a mutation, you first call `useOptimizeBoxFuelLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeBoxFuelLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeBoxFuelLevelsMutation, { data, loading, error }] = useOptimizeBoxFuelLevelsMutation({
 *   variables: {
 *      fuelLevel: // value for 'fuelLevel'
 *      availableBoxes: // value for 'availableBoxes'
 *   },
 * });
 */
export function useOptimizeBoxFuelLevelsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OptimizeBoxFuelLevelsMutation, OptimizeBoxFuelLevelsMutationVariables>) {
        return ApolloReactHooks.useMutation<OptimizeBoxFuelLevelsMutation, OptimizeBoxFuelLevelsMutationVariables>(OptimizeBoxFuelLevelsDocument, baseOptions);
      }
export type OptimizeBoxFuelLevelsMutationHookResult = ReturnType<typeof useOptimizeBoxFuelLevelsMutation>;
export type OptimizeBoxFuelLevelsMutationResult = ApolloReactCommon.MutationResult<OptimizeBoxFuelLevelsMutation>;
export type OptimizeBoxFuelLevelsMutationOptions = ApolloReactCommon.BaseMutationOptions<OptimizeBoxFuelLevelsMutation, OptimizeBoxFuelLevelsMutationVariables>;
export const CalculateBestBoxTypesDocument = gql`
    query calculateBestBoxTypes($options: BestBoxTypesOptCalcDTO!) {
  getBestBoxTypesForStorageEntriesAgg(options: $options) {
    data {
      agg {
        boxType {
          name
        }
        amount
      }
    }
  }
}
    `;

/**
 * __useCalculateBestBoxTypesQuery__
 *
 * To run a query within a React component, call `useCalculateBestBoxTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateBestBoxTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateBestBoxTypesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCalculateBestBoxTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CalculateBestBoxTypesQuery, CalculateBestBoxTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<CalculateBestBoxTypesQuery, CalculateBestBoxTypesQueryVariables>(CalculateBestBoxTypesDocument, baseOptions);
      }
export function useCalculateBestBoxTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CalculateBestBoxTypesQuery, CalculateBestBoxTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CalculateBestBoxTypesQuery, CalculateBestBoxTypesQueryVariables>(CalculateBestBoxTypesDocument, baseOptions);
        }
export type CalculateBestBoxTypesQueryHookResult = ReturnType<typeof useCalculateBestBoxTypesQuery>;
export type CalculateBestBoxTypesLazyQueryHookResult = ReturnType<typeof useCalculateBestBoxTypesLazyQuery>;
export type CalculateBestBoxTypesQueryResult = ApolloReactCommon.QueryResult<CalculateBestBoxTypesQuery, CalculateBestBoxTypesQueryVariables>;
export const AvgFuelStatDocument = gql`
    query avgFuelStat {
  getStatistics {
    fuelLevelStat {
      avg
    }
  }
}
    `;

/**
 * __useAvgFuelStatQuery__
 *
 * To run a query within a React component, call `useAvgFuelStatQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvgFuelStatQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvgFuelStatQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvgFuelStatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AvgFuelStatQuery, AvgFuelStatQueryVariables>) {
        return ApolloReactHooks.useQuery<AvgFuelStatQuery, AvgFuelStatQueryVariables>(AvgFuelStatDocument, baseOptions);
      }
export function useAvgFuelStatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvgFuelStatQuery, AvgFuelStatQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AvgFuelStatQuery, AvgFuelStatQueryVariables>(AvgFuelStatDocument, baseOptions);
        }
export type AvgFuelStatQueryHookResult = ReturnType<typeof useAvgFuelStatQuery>;
export type AvgFuelStatLazyQueryHookResult = ReturnType<typeof useAvgFuelStatLazyQuery>;
export type AvgFuelStatQueryResult = ApolloReactCommon.QueryResult<AvgFuelStatQuery, AvgFuelStatQueryVariables>;
export const CurrentAvailableBoxTypesDocument = gql`
    query currentAvailableBoxTypes {
  getStatistics {
    aggregateAvailableBoxTypes {
      count
      boxType {
        uuid
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentAvailableBoxTypesQuery__
 *
 * To run a query within a React component, call `useCurrentAvailableBoxTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAvailableBoxTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAvailableBoxTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAvailableBoxTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentAvailableBoxTypesQuery, CurrentAvailableBoxTypesQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentAvailableBoxTypesQuery, CurrentAvailableBoxTypesQueryVariables>(CurrentAvailableBoxTypesDocument, baseOptions);
      }
export function useCurrentAvailableBoxTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentAvailableBoxTypesQuery, CurrentAvailableBoxTypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentAvailableBoxTypesQuery, CurrentAvailableBoxTypesQueryVariables>(CurrentAvailableBoxTypesDocument, baseOptions);
        }
export type CurrentAvailableBoxTypesQueryHookResult = ReturnType<typeof useCurrentAvailableBoxTypesQuery>;
export type CurrentAvailableBoxTypesLazyQueryHookResult = ReturnType<typeof useCurrentAvailableBoxTypesLazyQuery>;
export type CurrentAvailableBoxTypesQueryResult = ApolloReactCommon.QueryResult<CurrentAvailableBoxTypesQuery, CurrentAvailableBoxTypesQueryVariables>;
export const CalculateNeededBoxesAdvancedDocument = gql`
    mutation calculateNeededBoxesAdvanced($fillingLevel: Float!, $selectedBoxes: [SelectedBoxDTO]) {
  calculateNeededBoxes(fillingLevel: $fillingLevel, selectedBoxes: $selectedBoxes) {
    success
    error {
      message
      code
    }
  }
}
    `;
export type CalculateNeededBoxesAdvancedMutationFn = ApolloReactCommon.MutationFunction<CalculateNeededBoxesAdvancedMutation, CalculateNeededBoxesAdvancedMutationVariables>;

/**
 * __useCalculateNeededBoxesAdvancedMutation__
 *
 * To run a mutation, you first call `useCalculateNeededBoxesAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateNeededBoxesAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateNeededBoxesAdvancedMutation, { data, loading, error }] = useCalculateNeededBoxesAdvancedMutation({
 *   variables: {
 *      fillingLevel: // value for 'fillingLevel'
 *      selectedBoxes: // value for 'selectedBoxes'
 *   },
 * });
 */
export function useCalculateNeededBoxesAdvancedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateNeededBoxesAdvancedMutation, CalculateNeededBoxesAdvancedMutationVariables>) {
        return ApolloReactHooks.useMutation<CalculateNeededBoxesAdvancedMutation, CalculateNeededBoxesAdvancedMutationVariables>(CalculateNeededBoxesAdvancedDocument, baseOptions);
      }
export type CalculateNeededBoxesAdvancedMutationHookResult = ReturnType<typeof useCalculateNeededBoxesAdvancedMutation>;
export type CalculateNeededBoxesAdvancedMutationResult = ApolloReactCommon.MutationResult<CalculateNeededBoxesAdvancedMutation>;
export type CalculateNeededBoxesAdvancedMutationOptions = ApolloReactCommon.BaseMutationOptions<CalculateNeededBoxesAdvancedMutation, CalculateNeededBoxesAdvancedMutationVariables>;
export const OptimizeStorageLocationsForZonesDocument = gql`
    mutation optimizeStorageLocationsForZones($zones: [String], $fillingLevel: Float!, $withFilling: Boolean, $trendFactor: Float, $maxBoxSkip: Int) {
  optimizeStorageLocationsForZones(zones: $zones, fillingLevel: $fillingLevel, withFilling: $withFilling, trendFactor: $trendFactor, maxBoxSkip: $maxBoxSkip) {
    error {
      message
      code
    }
    success
  }
}
    `;
export type OptimizeStorageLocationsForZonesMutationFn = ApolloReactCommon.MutationFunction<OptimizeStorageLocationsForZonesMutation, OptimizeStorageLocationsForZonesMutationVariables>;

/**
 * __useOptimizeStorageLocationsForZonesMutation__
 *
 * To run a mutation, you first call `useOptimizeStorageLocationsForZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeStorageLocationsForZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeStorageLocationsForZonesMutation, { data, loading, error }] = useOptimizeStorageLocationsForZonesMutation({
 *   variables: {
 *      zones: // value for 'zones'
 *      fillingLevel: // value for 'fillingLevel'
 *      withFilling: // value for 'withFilling'
 *      trendFactor: // value for 'trendFactor'
 *      maxBoxSkip: // value for 'maxBoxSkip'
 *   },
 * });
 */
export function useOptimizeStorageLocationsForZonesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OptimizeStorageLocationsForZonesMutation, OptimizeStorageLocationsForZonesMutationVariables>) {
        return ApolloReactHooks.useMutation<OptimizeStorageLocationsForZonesMutation, OptimizeStorageLocationsForZonesMutationVariables>(OptimizeStorageLocationsForZonesDocument, baseOptions);
      }
export type OptimizeStorageLocationsForZonesMutationHookResult = ReturnType<typeof useOptimizeStorageLocationsForZonesMutation>;
export type OptimizeStorageLocationsForZonesMutationResult = ApolloReactCommon.MutationResult<OptimizeStorageLocationsForZonesMutation>;
export type OptimizeStorageLocationsForZonesMutationOptions = ApolloReactCommon.BaseMutationOptions<OptimizeStorageLocationsForZonesMutation, OptimizeStorageLocationsForZonesMutationVariables>;
export const CurrentPackagetypesDocument = gql`
    query currentPackagetypes($pagination: PageableParam, $sort: [SortParam], $filter: [FilterParam], $q: String) {
  getPackageTypes(pagination: $pagination, sort: $sort, q: $q, filter: $filter) {
    data {
      uuid
      name
      width
      height
      depth
      volume
      isValid
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useCurrentPackagetypesQuery__
 *
 * To run a query within a React component, call `useCurrentPackagetypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPackagetypesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPackagetypesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useCurrentPackagetypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentPackagetypesQuery, CurrentPackagetypesQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentPackagetypesQuery, CurrentPackagetypesQueryVariables>(CurrentPackagetypesDocument, baseOptions);
      }
export function useCurrentPackagetypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentPackagetypesQuery, CurrentPackagetypesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentPackagetypesQuery, CurrentPackagetypesQueryVariables>(CurrentPackagetypesDocument, baseOptions);
        }
export type CurrentPackagetypesQueryHookResult = ReturnType<typeof useCurrentPackagetypesQuery>;
export type CurrentPackagetypesLazyQueryHookResult = ReturnType<typeof useCurrentPackagetypesLazyQuery>;
export type CurrentPackagetypesQueryResult = ApolloReactCommon.QueryResult<CurrentPackagetypesQuery, CurrentPackagetypesQueryVariables>;
export const GetPickZonesDocument = gql`
    query getPickZones($pagination: PageableParam, $filter: [FilterParam]) {
  getPickZones(filter: $filter, pagination: $pagination) {
    data {
      uuid
      name
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetPickZonesQuery__
 *
 * To run a query within a React component, call `useGetPickZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickZonesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPickZonesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPickZonesQuery, GetPickZonesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPickZonesQuery, GetPickZonesQueryVariables>(GetPickZonesDocument, baseOptions);
      }
export function useGetPickZonesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPickZonesQuery, GetPickZonesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPickZonesQuery, GetPickZonesQueryVariables>(GetPickZonesDocument, baseOptions);
        }
export type GetPickZonesQueryHookResult = ReturnType<typeof useGetPickZonesQuery>;
export type GetPickZonesLazyQueryHookResult = ReturnType<typeof useGetPickZonesLazyQuery>;
export type GetPickZonesQueryResult = ApolloReactCommon.QueryResult<GetPickZonesQuery, GetPickZonesQueryVariables>;
export const GetTenantsDocument = gql`
    query getTenants($q: String) {
  getTenants(q: $q) {
    data {
      uuid
      name
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, baseOptions);
      }
export function useGetTenantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, baseOptions);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsQueryResult = ApolloReactCommon.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const DeleteStorageConfigsDocument = gql`
    mutation deleteStorageConfigs($id: String) {
  deleteStorageConfig(id: $id) {
    success
    error {
      message
      code
    }
  }
}
    `;
export type DeleteStorageConfigsMutationFn = ApolloReactCommon.MutationFunction<DeleteStorageConfigsMutation, DeleteStorageConfigsMutationVariables>;

/**
 * __useDeleteStorageConfigsMutation__
 *
 * To run a mutation, you first call `useDeleteStorageConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorageConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorageConfigsMutation, { data, loading, error }] = useDeleteStorageConfigsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStorageConfigsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStorageConfigsMutation, DeleteStorageConfigsMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteStorageConfigsMutation, DeleteStorageConfigsMutationVariables>(DeleteStorageConfigsDocument, baseOptions);
      }
export type DeleteStorageConfigsMutationHookResult = ReturnType<typeof useDeleteStorageConfigsMutation>;
export type DeleteStorageConfigsMutationResult = ApolloReactCommon.MutationResult<DeleteStorageConfigsMutation>;
export type DeleteStorageConfigsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteStorageConfigsMutation, DeleteStorageConfigsMutationVariables>;
export const DeleteUnusedStorageConfigsDocument = gql`
    mutation deleteUnusedStorageConfigs {
  deleteUnusedStorageConfigs {
    success
    error {
      message
      code
    }
  }
}
    `;
export type DeleteUnusedStorageConfigsMutationFn = ApolloReactCommon.MutationFunction<DeleteUnusedStorageConfigsMutation, DeleteUnusedStorageConfigsMutationVariables>;

/**
 * __useDeleteUnusedStorageConfigsMutation__
 *
 * To run a mutation, you first call `useDeleteUnusedStorageConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnusedStorageConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnusedStorageConfigsMutation, { data, loading, error }] = useDeleteUnusedStorageConfigsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUnusedStorageConfigsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUnusedStorageConfigsMutation, DeleteUnusedStorageConfigsMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteUnusedStorageConfigsMutation, DeleteUnusedStorageConfigsMutationVariables>(DeleteUnusedStorageConfigsDocument, baseOptions);
      }
export type DeleteUnusedStorageConfigsMutationHookResult = ReturnType<typeof useDeleteUnusedStorageConfigsMutation>;
export type DeleteUnusedStorageConfigsMutationResult = ApolloReactCommon.MutationResult<DeleteUnusedStorageConfigsMutation>;
export type DeleteUnusedStorageConfigsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUnusedStorageConfigsMutation, DeleteUnusedStorageConfigsMutationVariables>;
export const GetCustomerGroupsDocument = gql`
    query getCustomerGroups($q: String) {
  getCustomerGroups(q: $q) {
    data {
      uuid
      value
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetCustomerGroupsQuery__
 *
 * To run a query within a React component, call `useGetCustomerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerGroupsQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetCustomerGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomerGroupsQuery, GetCustomerGroupsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCustomerGroupsQuery, GetCustomerGroupsQueryVariables>(GetCustomerGroupsDocument, baseOptions);
      }
export function useGetCustomerGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerGroupsQuery, GetCustomerGroupsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCustomerGroupsQuery, GetCustomerGroupsQueryVariables>(GetCustomerGroupsDocument, baseOptions);
        }
export type GetCustomerGroupsQueryHookResult = ReturnType<typeof useGetCustomerGroupsQuery>;
export type GetCustomerGroupsLazyQueryHookResult = ReturnType<typeof useGetCustomerGroupsLazyQuery>;
export type GetCustomerGroupsQueryResult = ApolloReactCommon.QueryResult<GetCustomerGroupsQuery, GetCustomerGroupsQueryVariables>;
export const CurrentStorageconfigsDocument = gql`
    query currentStorageconfigs($pagination: PageableParam) {
  getStorageConfigs(pagination: $pagination) {
    data {
      uuid
      zoneEffFactor
      currentPickZone {
        name
        next
        distance
      }
      estimatedPickZone {
        next
        distance
      }
      zoneEffFactor
      customerGroups
      effCalcDone
      zone
      isFlowRackZone
      bestPosition
      racks {
        name
        count
      }
      flowRackBoxes {
        count
        box {
          name
        }
      }
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useCurrentStorageconfigsQuery__
 *
 * To run a query within a React component, call `useCurrentStorageconfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentStorageconfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentStorageconfigsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCurrentStorageconfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentStorageconfigsQuery, CurrentStorageconfigsQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentStorageconfigsQuery, CurrentStorageconfigsQueryVariables>(CurrentStorageconfigsDocument, baseOptions);
      }
export function useCurrentStorageconfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentStorageconfigsQuery, CurrentStorageconfigsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentStorageconfigsQuery, CurrentStorageconfigsQueryVariables>(CurrentStorageconfigsDocument, baseOptions);
        }
export type CurrentStorageconfigsQueryHookResult = ReturnType<typeof useCurrentStorageconfigsQuery>;
export type CurrentStorageconfigsLazyQueryHookResult = ReturnType<typeof useCurrentStorageconfigsLazyQuery>;
export type CurrentStorageconfigsQueryResult = ApolloReactCommon.QueryResult<CurrentStorageconfigsQuery, CurrentStorageconfigsQueryVariables>;
export const GetCurrentStorageconfigDocument = gql`
    query getCurrentStorageconfig($id: String) {
  getStorageConfig(id: $id) {
    data {
      uuid
      zone
      zoneEffFactor
      bestPosition
      racks {
        name
        count
      }
      currentPickZone {
        next
        name
        distance
      }
      estimatedPickZone {
        next
        name
        distance
      }
      customerGroups
      isFlowRackZone
      flowRackBoxes {
        count
        box {
          uuid
          name
        }
      }
    }
    meta {
      count
      offset
      size
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetCurrentStorageconfigQuery__
 *
 * To run a query within a React component, call `useGetCurrentStorageconfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStorageconfigQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStorageconfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentStorageconfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentStorageconfigQuery, GetCurrentStorageconfigQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCurrentStorageconfigQuery, GetCurrentStorageconfigQueryVariables>(GetCurrentStorageconfigDocument, baseOptions);
      }
export function useGetCurrentStorageconfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentStorageconfigQuery, GetCurrentStorageconfigQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCurrentStorageconfigQuery, GetCurrentStorageconfigQueryVariables>(GetCurrentStorageconfigDocument, baseOptions);
        }
export type GetCurrentStorageconfigQueryHookResult = ReturnType<typeof useGetCurrentStorageconfigQuery>;
export type GetCurrentStorageconfigLazyQueryHookResult = ReturnType<typeof useGetCurrentStorageconfigLazyQuery>;
export type GetCurrentStorageconfigQueryResult = ApolloReactCommon.QueryResult<GetCurrentStorageconfigQuery, GetCurrentStorageconfigQueryVariables>;
export const GetBoxesPerRackDocument = gql`
    query getBoxesPerRack($zone: String!) {
  getBoxesPerZone(zone: $zone) {
    data {
      uuid
      name
    }
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetBoxesPerRackQuery__
 *
 * To run a query within a React component, call `useGetBoxesPerRackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxesPerRackQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxesPerRackQuery({
 *   variables: {
 *      zone: // value for 'zone'
 *   },
 * });
 */
export function useGetBoxesPerRackQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBoxesPerRackQuery, GetBoxesPerRackQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBoxesPerRackQuery, GetBoxesPerRackQueryVariables>(GetBoxesPerRackDocument, baseOptions);
      }
export function useGetBoxesPerRackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoxesPerRackQuery, GetBoxesPerRackQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBoxesPerRackQuery, GetBoxesPerRackQueryVariables>(GetBoxesPerRackDocument, baseOptions);
        }
export type GetBoxesPerRackQueryHookResult = ReturnType<typeof useGetBoxesPerRackQuery>;
export type GetBoxesPerRackLazyQueryHookResult = ReturnType<typeof useGetBoxesPerRackLazyQuery>;
export type GetBoxesPerRackQueryResult = ApolloReactCommon.QueryResult<GetBoxesPerRackQuery, GetBoxesPerRackQueryVariables>;
export const AssignTenantDocument = gql`
    mutation assignTenant($userId: String!, $tenantId: String!) {
  assignTenant(userId: $userId, tenantId: $tenantId) {
    success
    error {
      code
      message
    }
  }
}
    `;
export type AssignTenantMutationFn = ApolloReactCommon.MutationFunction<AssignTenantMutation, AssignTenantMutationVariables>;

/**
 * __useAssignTenantMutation__
 *
 * To run a mutation, you first call `useAssignTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTenantMutation, { data, loading, error }] = useAssignTenantMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAssignTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignTenantMutation, AssignTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<AssignTenantMutation, AssignTenantMutationVariables>(AssignTenantDocument, baseOptions);
      }
export type AssignTenantMutationHookResult = ReturnType<typeof useAssignTenantMutation>;
export type AssignTenantMutationResult = ApolloReactCommon.MutationResult<AssignTenantMutation>;
export type AssignTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignTenantMutation, AssignTenantMutationVariables>;
export const UpdateStorageConfigQueryDocument = gql`
    mutation updateStorageConfigQuery($id: String!, $config: StorageConfigUpdateInput!) {
  updateStorageConfig(uuid: $id, config: $config) {
    data {
      uuid
      zone
      bestPosition
      effCalcDone
      zoneEffFactor
      currentPickZone {
        next
        distance
      }
      estimatedPickZone {
        next
        distance
      }
      customerGroups
      isFlowRackZone
      flowRackBoxes {
        count
        box {
          name
        }
      }
    }
    meta {
      offset
      count
      size
    }
    error {
      message
      code
    }
  }
}
    `;
export type UpdateStorageConfigQueryMutationFn = ApolloReactCommon.MutationFunction<UpdateStorageConfigQueryMutation, UpdateStorageConfigQueryMutationVariables>;

/**
 * __useUpdateStorageConfigQueryMutation__
 *
 * To run a mutation, you first call `useUpdateStorageConfigQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorageConfigQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorageConfigQueryMutation, { data, loading, error }] = useUpdateStorageConfigQueryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateStorageConfigQueryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStorageConfigQueryMutation, UpdateStorageConfigQueryMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateStorageConfigQueryMutation, UpdateStorageConfigQueryMutationVariables>(UpdateStorageConfigQueryDocument, baseOptions);
      }
export type UpdateStorageConfigQueryMutationHookResult = ReturnType<typeof useUpdateStorageConfigQueryMutation>;
export type UpdateStorageConfigQueryMutationResult = ApolloReactCommon.MutationResult<UpdateStorageConfigQueryMutation>;
export type UpdateStorageConfigQueryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStorageConfigQueryMutation, UpdateStorageConfigQueryMutationVariables>;
export const GetMeDocument = gql`
    query getMe {
  getMe {
    data {
      uuid
      name
      surname
      department
      email
      roles
      tenant {
        uuid
        name
        config {
          desiredFuelLevel
          storageLocationConfig {
            zone
            rack
            level
            position
            section
          }
          efficiencyCalcSetting {
            verticalUp
            verticalDown
            horizontal
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
      }
export function useGetMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, baseOptions);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = ApolloReactCommon.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetProcessLogsDocument = gql`
    query getProcessLogs($filter: [FilterParam], $pagination: PageableParam, $sort: [SortParam], $q: String) {
  getProcessLogs(filter: $filter, pagination: $pagination, sort: $sort, q: $q) {
    data {
      uuid
      start
      status
      meta
      meta2 {
        params {
          name
          value
          type
        }
        result {
          name
          value
          type
        }
      }
      message
      type
    }
    meta {
      size
      offset
      count
    }
  }
}
    `;

/**
 * __useGetProcessLogsQuery__
 *
 * To run a query within a React component, call `useGetProcessLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetProcessLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProcessLogsQuery, GetProcessLogsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetProcessLogsQuery, GetProcessLogsQueryVariables>(GetProcessLogsDocument, baseOptions);
      }
export function useGetProcessLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProcessLogsQuery, GetProcessLogsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetProcessLogsQuery, GetProcessLogsQueryVariables>(GetProcessLogsDocument, baseOptions);
        }
export type GetProcessLogsQueryHookResult = ReturnType<typeof useGetProcessLogsQuery>;
export type GetProcessLogsLazyQueryHookResult = ReturnType<typeof useGetProcessLogsLazyQuery>;
export type GetProcessLogsQueryResult = ApolloReactCommon.QueryResult<GetProcessLogsQuery, GetProcessLogsQueryVariables>;
export const UpdateTenantDocument = gql`
    mutation updateTenant($id: String, $tenant: TenantInput) {
  updateTenant(id: $id, tenant: $tenant) {
    data {
      name
      config {
        desiredFuelLevel
        storageLocationConfig {
          zone
        }
        efficiencyCalcSetting {
          verticalUp
        }
      }
    }
    error {
      ...ErrorParts
    }
  }
}
    ${ErrorPartsFragmentDoc}`;
export type UpdateTenantMutationFn = ApolloReactCommon.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, baseOptions);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = ApolloReactCommon.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const GetTenantDocument = gql`
    query getTenant($id: String) {
  getTenant(id: $id) {
    data {
      uuid
      name
      config {
        desiredFuelLevel
        storageLocationConfig {
          zone
          rack
          level
          position
          section
        }
        efficiencyCalcSetting {
          verticalUp
          verticalDown
          horizontal
        }
      }
    }
    error {
      ...ErrorParts
    }
  }
}
    ${ErrorPartsFragmentDoc}`;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, baseOptions);
      }
export function useGetTenantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, baseOptions);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantQueryResult = ApolloReactCommon.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const FuelLevelStatQueryDocument = gql`
    query fuelLevelStatQuery {
  getStatistics {
    fuelLevelStat {
      avg
      amountOfInvalidFuelLevel
      amountWithFuelLevel
    }
  }
}
    `;

/**
 * __useFuelLevelStatQueryQuery__
 *
 * To run a query within a React component, call `useFuelLevelStatQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFuelLevelStatQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFuelLevelStatQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFuelLevelStatQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FuelLevelStatQueryQuery, FuelLevelStatQueryQueryVariables>) {
        return ApolloReactHooks.useQuery<FuelLevelStatQueryQuery, FuelLevelStatQueryQueryVariables>(FuelLevelStatQueryDocument, baseOptions);
      }
export function useFuelLevelStatQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FuelLevelStatQueryQuery, FuelLevelStatQueryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FuelLevelStatQueryQuery, FuelLevelStatQueryQueryVariables>(FuelLevelStatQueryDocument, baseOptions);
        }
export type FuelLevelStatQueryQueryHookResult = ReturnType<typeof useFuelLevelStatQueryQuery>;
export type FuelLevelStatQueryLazyQueryHookResult = ReturnType<typeof useFuelLevelStatQueryLazyQuery>;
export type FuelLevelStatQueryQueryResult = ApolloReactCommon.QueryResult<FuelLevelStatQueryQuery, FuelLevelStatQueryQueryVariables>;
export const GetStatisticsDocument = gql`
    query getStatistics {
  getStatistics {
    packageTypeStat {
      count
      valid
    }
    boxTypeStat {
      count
      active
      valid
    }
    storageStructureStat {
      pickZones
      zones
      racks
      levels
      positions
      sections
      customerGroups
    }
    storageEntryStat {
      count
      reserved
      inUse
      free
    }
    aggregateBoxTypes {
      count
      boxType {
        uuid
        name
        isValid
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetStatisticsQuery__
 *
 * To run a query within a React component, call `useGetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, baseOptions);
      }
export function useGetStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatisticsQuery, GetStatisticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStatisticsQuery, GetStatisticsQueryVariables>(GetStatisticsDocument, baseOptions);
        }
export type GetStatisticsQueryHookResult = ReturnType<typeof useGetStatisticsQuery>;
export type GetStatisticsLazyQueryHookResult = ReturnType<typeof useGetStatisticsLazyQuery>;
export type GetStatisticsQueryResult = ApolloReactCommon.QueryResult<GetStatisticsQuery, GetStatisticsQueryVariables>;
export const ImportMaterialsDocument = gql`
    mutation importMaterials {
  importMaterials {
    success
    error {
      message
      code
    }
  }
}
    `;
export type ImportMaterialsMutationFn = ApolloReactCommon.MutationFunction<ImportMaterialsMutation, ImportMaterialsMutationVariables>;

/**
 * __useImportMaterialsMutation__
 *
 * To run a mutation, you first call `useImportMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMaterialsMutation, { data, loading, error }] = useImportMaterialsMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportMaterialsMutation, ImportMaterialsMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportMaterialsMutation, ImportMaterialsMutationVariables>(ImportMaterialsDocument, baseOptions);
      }
export type ImportMaterialsMutationHookResult = ReturnType<typeof useImportMaterialsMutation>;
export type ImportMaterialsMutationResult = ApolloReactCommon.MutationResult<ImportMaterialsMutation>;
export type ImportMaterialsMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportMaterialsMutation, ImportMaterialsMutationVariables>;
export const ImportPackageTypesDocument = gql`
    mutation importPackageTypes {
  importPackageTypes {
    success
    error {
      message
      code
    }
  }
}
    `;
export type ImportPackageTypesMutationFn = ApolloReactCommon.MutationFunction<ImportPackageTypesMutation, ImportPackageTypesMutationVariables>;

/**
 * __useImportPackageTypesMutation__
 *
 * To run a mutation, you first call `useImportPackageTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPackageTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPackageTypesMutation, { data, loading, error }] = useImportPackageTypesMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportPackageTypesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportPackageTypesMutation, ImportPackageTypesMutationVariables>) {
        return ApolloReactHooks.useMutation<ImportPackageTypesMutation, ImportPackageTypesMutationVariables>(ImportPackageTypesDocument, baseOptions);
      }
export type ImportPackageTypesMutationHookResult = ReturnType<typeof useImportPackageTypesMutation>;
export type ImportPackageTypesMutationResult = ApolloReactCommon.MutationResult<ImportPackageTypesMutation>;
export type ImportPackageTypesMutationOptions = ApolloReactCommon.BaseMutationOptions<ImportPackageTypesMutation, ImportPackageTypesMutationVariables>;
export const StorageEntriesDocument = gql`
    query storageEntries($pagination: PageableParam, $sort: [SortParam], $filter: [FilterParam], $q: String) {
  getEntries(pagination: $pagination, sort: $sort, q: $q, filter: $filter) {
    data {
      ...StorageEntryParts
    }
    meta {
      ...MetaDTOParts
    }
    error {
      ...ErrorParts
    }
  }
}
    ${StorageEntryPartsFragmentDoc}
${MetaDtoPartsFragmentDoc}
${ErrorPartsFragmentDoc}`;

/**
 * __useStorageEntriesQuery__
 *
 * To run a query within a React component, call `useStorageEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageEntriesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useStorageEntriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorageEntriesQuery, StorageEntriesQueryVariables>) {
        return ApolloReactHooks.useQuery<StorageEntriesQuery, StorageEntriesQueryVariables>(StorageEntriesDocument, baseOptions);
      }
export function useStorageEntriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageEntriesQuery, StorageEntriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<StorageEntriesQuery, StorageEntriesQueryVariables>(StorageEntriesDocument, baseOptions);
        }
export type StorageEntriesQueryHookResult = ReturnType<typeof useStorageEntriesQuery>;
export type StorageEntriesLazyQueryHookResult = ReturnType<typeof useStorageEntriesLazyQuery>;
export type StorageEntriesQueryResult = ApolloReactCommon.QueryResult<StorageEntriesQuery, StorageEntriesQueryVariables>;